<template>
  <div class="notifications header-item">
    <b-dropdown position="is-bottom-left">
      <a class="notifications-trigger" slot="trigger" @click="loadData">
              <span class="icon-holder">
                <span v-if="unread > 0">{{ unread }}</span>
                <img src="../assets/notifications.svg" alt="Notifications">
              </span>
      </a>
      <b-dropdown-item custom paddingless>
        <div class="notification-content">
          <div class="level">
            <div class="level-left">
              <img src="../assets/notifications.svg" alt="">
              <h4 class="title is-5 has-text-grey">{{ $t('interface.notifications') }}</h4>
            </div>
            <div class="level-right">
              <!--<span class="is-pulled-right">
                <a class="is-small">Отчистить все</a>
              </span>-->
            </div>
          </div>
          <template v-if="notifications.length > 0">
            <div v-for="notification in notifications" class="media">
              <figure class="media-left">
                <p class="image">
                  <img src="../assets/demo/notification-icon.svg" alt="">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p>
                    <a @click="goTo(notification.data.action_object)">
                      <strong>{{ $t(`notification.verbs.${notification.verb}`) }}</strong>
                    </a>
                    <br>
                    <span>{{ notification.text }}</span>
                  </p>
                  <p class="has-text-grey">
                    <small>{{ notification.created_at | localedRelativeDate }}</small>
                  </p>
                </div>
              </div>
            </div>
          </template>
          <p v-else class="has-text-grey-light">{{ $t('interface.notificationsEmpty') }}</p>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {docflowRoutes} from '@/constants'

  export default {
    data() {
      return {
        timer: null,
        unread: 0
      }
    },
    methods: {
      loadData() {
        this.$store.dispatch('Account/notificationsList').then(() => this.unread = 0)
      },
      goTo(action) {
        if (action.type === 'task') {
          this.$router.push({
            name: 'taskDetail',
            params: {
              taskId: action.id,
              documentId: action.document_id
            }
          })
        } else if (action.type === 'assignment') {
          this.$router.push({
            name: 'documentDetail',
            params: {
              documentId: action.id
            }
          })
        } else if(action.type === 'survey') {
          this.$router.push({
            name: 'surveyDetail',
            params: {
              surveyId: action.id
            }
          })
        } else if (action.type === 'document') {
          this.$router.push({
            name: docflowRoutes[action.category],
            params: {
              documentId: action.id
            }
          })
        } else if (action.type === 'issue') {
          this.$router.push({
            name: 'issueDetail',
            params: {
              issueId: action.id
            }
          })
        }
      }
    },
    created() {
      this.timer = setInterval(() => {
        this.$axios.get('notifier/unread_count/', { __silent: true }).then((response) => {
          this.unread = response.data.count
        })
      }, 15 * 1000)
    },
    destroyed() {
      clearInterval(this.timer)
    },
    computed: {
      ...mapState('Account', ['notifications'])
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/variables";

  .notifications {
    .notifications-trigger {
      padding: 0 30px;
      height: $header-height;
      line-height: calc(#{$header-height} + 1px);


      .icon-holder {
        display: inline-block;
        position: relative;
        top: 4px;

        span {
          display: block;
          position: absolute;
          width: 14px;
          height: 14px;
          background: #EB3232;
          border-radius: 50%;
          color: #fff;
          font-size: 9px;
          line-height: 13px;
          text-align: center;
          top: 18px;
          right: -8px;
        }
      }
    }

    .notification-content {
      background: #fff;
      position: relative;
      z-index: 9;
      padding: 40px 42px 30px 42px;
      width: 420px;
      max-height: 500px;
      overflow: auto;

      .content p:not(:last-child) {
        margin-bottom: 10px;
      }

      .media a {
        color: #3498db;
        font-size: 14px;

        &:hover {
          color: #4e4e4e;
        }
      }

      .level {
        margin-bottom: 40px;
      }

      .title.is-5 {
        font-size: 17px;
        margin-left: 12px;
        font-weight: normal;
      }

      .content span {
        font-size: 15px;
      }

      .media {
        border-top: 0;
        margin-top: 6px;

        img {
          width: 100%;
          margin-top: 4px;
        }
      }
    }
  }
</style>